import { render, staticRenderFns } from "./ProductImport.vue?vue&type=template&id=24a87cf2&"
import script from "./ProductImport.vue?vue&type=script&lang=ts&"
export * from "./ProductImport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports